export const ListQueryKey = 'zeroRecommendConfigs';
export const DetailQueryKey = 'zeroRecommendConfig';

export const Urls = {
  selectUrl: '/zeroRecommendConfig/list',
  updateUrl: '/zeroRecommendConfig/update',
  deleteUrl: '/zeroRecommendConfig/delete',
  createUrl: '/zeroRecommendConfig/create',
  detailUrl: '/zeroRecommendConfig/detail',
};
